export default {
	add_to_your_calendar: "Add to your calendar",
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Explore our universe of courses, videos, articles and exclusive files.",
	no_events_available_for_the_selected_date: "No events available.",
	welcome_to: "Welcome to",
	what_do_you_want_to_learn_today: "What do you want to learn today?"
}